module.exports = __webpack_public_path__ + "static/media/1on1_asset.81cf532f.svg";